var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsIconBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44444 8.99957C5.44444 9.58894 5.21032 10.1542 4.79357 10.5709C4.37682 10.9877 3.81159 11.2218 3.22222 11.2218C2.63285 11.2218 2.06762 10.9877 1.65087 10.5709C1.23413 10.1542 1 9.58894 1 8.99957C1 8.4102 1.23413 7.84497 1.65087 7.42822C2.06762 7.01147 2.63285 6.77734 3.22222 6.77734C3.81159 6.77734 4.37682 7.01147 4.79357 7.42822C5.21032 7.84497 5.44444 8.4102 5.44444 8.99957Z",
    stroke: "#23272E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88878 4.11133L5.44434 7.22244M9.88878 13.8891L5.44434 10.778",
    stroke: "#23272E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 14.7778C14.3334 15.3671 14.0992 15.9324 13.6825 16.3491C13.2657 16.7659 12.7005 17 12.1111 17C11.5218 17 10.9565 16.7659 10.5398 16.3491C10.123 15.9324 9.88892 15.3671 9.88892 14.7778C9.88892 14.1884 10.123 13.6232 10.5398 13.2064C10.9565 12.7897 11.5218 12.5556 12.1111 12.5556C12.7005 12.5556 13.2657 12.7897 13.6825 13.2064C14.0992 13.6232 14.3334 14.1884 14.3334 14.7778ZM14.3334 3.22222C14.3334 3.81159 14.0992 4.37682 13.6825 4.79357C13.2657 5.21032 12.7005 5.44444 12.1111 5.44444C11.5218 5.44444 10.9565 5.21032 10.5398 4.79357C10.123 4.37682 9.88892 3.81159 9.88892 3.22222C9.88892 2.63285 10.123 2.06762 10.5398 1.65087C10.9565 1.23413 11.5218 1 12.1111 1C12.7005 1 13.2657 1.23413 13.6825 1.65087C14.0992 2.06762 14.3334 2.63285 14.3334 3.22222Z",
    stroke: "#23272E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconBold);
export default __webpack_public_path__ + "static/media/ContactUsIconBold.46352575408d85e732e216410d38987d.svg";
export { ForwardRef as ReactComponent };